<template lang="pug">
  el-col.container-input
    div.upload-area(:id="id")
      transition(name="idle-fade")
        div.content.content-idle(v-if="!loading && !success" :class="{'error-upload' : errors.length}")
          .info Arraste e solte ou clique para selecionar um arquivo.
          .format Formato(s) suportado(s): {{this.fileType.join(', ')}}
      span(v-if="!loading").help.erro {{ errors[0] }}
      transition(name="width")
        el-row.content.content-loader(v-if="loading" :style="{width: (percentage < 20 ? 20 : percentage).toString() + '%'}")
          el-col.column(:span="12")
            div.name {{ fileName }}
            div(v-if="fileSize && !isNaN(fileSize)").size {{ fileSize }} Kb
          transition(name="buttons-and-label-fade")
            el-col.column.right.float-left(v-if="success" :span="12")
              div.label Carregado com sucesso!
    transition(name="buttons-and-label-fade")
      div.buttons(v-if="success")
        el-button(
          name="excluir"
          class="excluir"
          @click="excluir"
        )
          span.center
            i.fas.fa-times
            b &nbsp Remover
        el-button(
          v-if="hasDownloadButton"
          name="download"
          class="download"
          @click="download"
        )
          span.center
            i.fas.fa-download
            b &nbsp Download

    app-resumable(
      :ref="id",
      :target="target",
      :fileType="fileType",
      :idDrop="id",
      :idInput="id",
      :fileTypeErrorCallback="fileTypeErrorCallback"
      @onSuccess="onSuccessEvent",
      @onError="onErrorEvent",
      @onProgress="onProgressEvent",
      @fileAdded="onFileAddedEvent"
      :maxSize="maxSize || null"
    )
</template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppResumable from '@/components/AppResumable'

export default {
  components: {
    AppResumable
  },
  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      style: null,
      success: false,
      loading: false,
      percentage: 0,
      fileName: '',
      fileSize: ''
    }
  },
  props: {
    id: {
      type: String,
      required: true
    },

    target: {
      type: String,
      required: true
    },

    fileType: {
      type: Array,
      required: true
    },

    onSuccess: {
      type: Function,
      required: false,
      default: () => { }
    },

    onFileAdded: {
      type: Function,
      required: false,
      default: () => { }
    },

    onError: {
      type: Function,
      required: false,
      default: () => { }
    },

    onProgress: {
      type: Function,
      required: false,
      default: () => { }
    },

    documento: {
      type: Object,
      required: false
    },

    errors: {
      required: false,
      type: Array,
      default: () => []
    },

    maxSize: {
      type: Number
    },

    hasDownloadButton: {
      type: Boolean,
      default: true
    }
  },

  mounted () {
    if (this.documento) {
      this.loading = true
      this.success = true
      this.fileName = this.documento.nomeOriginal || this.documento.fileName
      this.fileSize = this.formatFileSize(this.documento.tamanho)
      this.percentage = 100
    }
  },

  methods: {
    formatFileSize (input) {
      return parseFloat((input / 1000).toFixed(2)).toLocaleString('pt-BR').toString()
    },
    clear () {
      this.loading = false
      this.success = false
      this.fileName = ''
      this.fileSize = ''
      this.percentage = 0
    },

    excluir () {
      this.clear()
      this.$emit('removerDocumento', this.id)
    },
    download () {
      this.$emit('download', this.id)
    },

    fileTypeErrorCallback () {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
        this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.fileType.join(', ')))
    },
    onSuccessEvent (value, fileKey) {
      this.success = true
      this.$props.onSuccess(this.$props.id, value, fileKey)
    },
    onFileAddedEvent (file) {
      this.$refs[this.$props.id].uploadFile()
      this.loading = true
      this.fileName = file.file.name
      this.fileSize = this.formatFileSize(file.size)
      this.$props.onFileAdded(this.$props.id, file)
    },
    onErrorEvent (message) {
      this.loading = false
      this.$props.onError(this.$props.id, message)
    },
    onProgressEvent (progress) {
      this.percentage = progress
      this.$props.onProgress(this.$props.id, progress)
    }
  },

  watch: {
    documento: {

      handler (val) {
        if (val && !val.removed) {
          this.loading = true
          this.success = true
          this.fileName = val.nomeOriginal
          this.fileSize = this.formatFileSize(val.tamanho)
          this.percentage = 100
        } else {
          this.clear()
        }
      },

      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.upload-area {
  width: 100%;
}

.float-left {
  float: left
}

.content {
  border-radius: 4px;
  width: 100%;
  height: 7rem;
  padding: 1rem;
}

.content-idle {
  background-color: $border-color;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .info {
    color: $font-dark-color;
    font-weight: normal;
  }
  .format {
    padding-top: 0.25rem;
    font-size: 0.9rem;
    font-weight: normal;
  }
}

.content-loader {
  background-color: $color-primary;
}

.label,
.name {
  color: $white;
}

.column {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.buttons {
  margin-top: 1rem;
  float: right;
}

.right {
  align-items: flex-end;
}

.label {
  font-weight: bold;
}

.size {
  color: $border-color;
}

.excluir {
  color: $error;
}

.excluir:hover {
  background-color: #fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}

.width-enter-active {
  transition: width 2s;
}

.width-enter {
  width: 20%;
}

.idle-fade-enter-active {
  transition: opacity 1s;
}

.idle-fade-enter {
  opacity: 0;
}

.buttons-and-label-fade-leave-active {
  transition: opacity 0.5s;
}

.buttons-and-label-fade-leave-to {
  opacity: 0;
}

.buttons-and-label-fade-enter-active {
  transition: opacity 3s;
}

.buttons-and-label-fade-enter {
  opacity: 0;
}

.error-upload {
  border: 1px solid $error;
  border-radius: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppUploadArea.vue